import ApiBase from './api-base'
import Ajax from '../common/ajax'
import store from '../store'

export default {
  ...ApiBase,
  model: 'user',
  sendVcode (mobile, smsType) {
    return Ajax.post(`/api/gradeOrganization/v1/user/authcode`, { mobile, smsType })
  },
  loginByVcode (mobile, vcode, passWord) {
    let appInfo = store.state.appInfo
    return Ajax.post(`/api/gradeOrganization/v1/${this.model}/login`, { mobile: mobile, authCode: vcode, passWord: passWord, organizationId: appInfo.organizationId })
  },
  loginByPass (mobile, password) {
    return Ajax.post(`/api/gradeOrganization/v1/${this.model}/loginByPass`, { mobile, password })
  },
  resetPass (mobile, vcode, newPass) {
    return Ajax.post(`/api/gradeOrganization/v1/${this.model}/resetPass`, { mobile, vcode, newPass })
  },
  changePass (param) {
    return Ajax.post(`/api/gradeOrganization/v1/${this.model}/changePassWord`, param)
  },
  resetPassWord (userId) {
    return Ajax.post(`/api/gradeOrganization/v1/${this.model}/resetPassWord`, { userId })
  },
  getPageTeacher (data = {}) {
    return Ajax.post(`/api/gradeOrganization/v1/statistics/pageTeacher`, data)
  },
  getTeacherList (data = {}) {
    return Ajax.post(`/api/gradeOrganization/v1/${this.model}/listOrgUser`, data)
  }
}
